import { takeLatest, takeEvery, call, put, select } from 'redux-saga/effects';
import { AssetDetailsApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';
import {
    getFFTAction,
    getFFTTimestampAction,
    setSelectedTimestamps,
    setSelected2DTimestamp,
    get2DFFTAction
} from './actions';
import { getSelectedAsset } from '../selectors';
import { getSelectedOrganization } from '../SingleChartView/Trend/TrendChart/selectors';

// eslint-disable-next-line import/no-unused-modules
export function* fetchFFTV2() {
    yield put(getFFTAction(apiCallStatus.LOADING));
    yield put(get2DFFTAction(apiCallStatus.LOADING));
    try {
        const selectedAsset = yield select(state => getSelectedAsset(state));
        const selectedOrganization = yield select(state => getSelectedOrganization(state));
        const response = yield call(AssetDetailsApi.getFFTV2Data, selectedAsset.id);
        yield put(getFFTAction(apiCallStatus.SUCCESS, response));
        yield put(get2DFFTAction(apiCallStatus.SUCCESS, response));
        if (response?.[0]?.timestamp) {
            yield put(setSelected2DTimestamp([response?.[0]?.timestamp], selectedAsset, selectedOrganization));
            yield put(setSelectedTimestamps([response?.[0]?.timestamp], selectedAsset, selectedOrganization));
        }
    } catch (err) {
        yield put(getFFTAction(apiCallStatus.ERROR, [], err));
        yield put(get2DFFTAction(apiCallStatus.ERROR, [], err));
    }
}

// eslint-disable-next-line import/no-unused-modules
export function* fetchFFTTimestampList({ startTime, endTime }) {
    yield put(getFFTTimestampAction(apiCallStatus.LOADING));
    try {
        const selectedAsset = yield select(state => getSelectedAsset(state));
        const response = yield call(AssetDetailsApi.getFFTTimestampList, selectedAsset.id, startTime, endTime);
        yield put(getFFTTimestampAction(apiCallStatus.SUCCESS, response));
    } catch (err) {
        yield put(getFFTTimestampAction(apiCallStatus.ERROR, [], err));
    }
}

// eslint-disable-next-line import/no-unused-modules
export function* fetchFFTDataByTimestamp({ fftTimestamps, setShowHistoricalDialog, isFor2d }) {
    if (isFor2d) {
        yield put(get2DFFTAction(apiCallStatus.LOADING));
    } else {
        yield put(getFFTAction(apiCallStatus.LOADING));
    }
    try {
        const selectedAsset = yield select(state => getSelectedAsset(state));
        const params = {
            assetId: selectedAsset.id,
            fftTimestamp: fftTimestamps
        };
        const response = yield call(AssetDetailsApi.getFFTDataByTimestamp, params);
        if (setShowHistoricalDialog) {
            setShowHistoricalDialog(false);
        }
        if (isFor2d) {
            yield put(get2DFFTAction(apiCallStatus.SUCCESS, response));
        } else {
            yield put(getFFTAction(apiCallStatus.SUCCESS, response));
        }
    } catch (err) {
        if (isFor2d) {
            yield put(get2DFFTAction(apiCallStatus.ERROR, [], err));
        } else {
            yield put(getFFTAction(apiCallStatus.ERROR, [], err));
        }
    }
}

export function* vibrationFFTV2Watchers() {
    yield takeLatest(actionTypes.GET_FFT_V2_REQUEST, fetchFFTV2);
    yield takeLatest(actionTypes.GET_FFT_V2_TIMESTAMP_LIST_REQUEST, fetchFFTTimestampList);
    yield takeEvery(actionTypes.GET_FFT_V2_DATA_BY_TIMESTAMP_REQUEST, fetchFFTDataByTimestamp);
}
